import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {isNotBlankOrEmpty} from '@/engine/utils/string';
import {useFormatFullName} from '@/hooks/use-format-fullname';
import {DocumentStore} from '../../store/document-store';
import {useDocumentUtils} from '../../utils/use-document-utils';

export const useOnDocumentInfoChange = () => {
  const {t} = useTranslation();
  const {valueResolver} = useDocumentUtils();
  const formatFullName = useFormatFullName();

  return useCallback(
    (changedKeys: string[], state: DocumentStore) => {
      if (changedKeys.includes('A3') || changedKeys.includes('A2')) {
        const formattedName = formatFullName(valueResolver(state.data.A3), valueResolver(state.data.A2));
        const defaultName = t('components.document-menu.new-document-name');

        state.updateMeta('name', isNotBlankOrEmpty(formattedName) ? formattedName : defaultName);
      }

      if (changedKeys.includes('C1')) {
        state.updateMeta('type', valueResolver(state.data.C1));
      }
    },
    [formatFullName, t, valueResolver],
  );
};
